import {
  Component,
  ElementRef,
  inject,
  viewChild,
  ViewChild,
} from '@angular/core';
import { ModalsComponent } from '../../../common/modals/modals.component';
import { RouterOutlet } from '@angular/router';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import {
  SidebarComponent,
  SidebarLink,
} from '../../../common/internal-sidebar/internal-sidebar.component';
import { ToastComponent } from '../../../common/toast/toast.component';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { HeaderComponent } from 'src/app/common/templates/header/header.component';
import { FooterComponent } from 'src/app/common/templates/footer/footer.component';
import { PreviewImageComponent } from 'src/app/common/preview-image/preview-image.component';
import { PreviewImageService } from 'src/app/services/Image-preview/preview-image-service.service';

@Component({
  selector: 'approver-template',
  imports: [
    ModalsComponent,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ToastComponent,
    PreviewImageComponent,
  ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss',
})
export class TemplateComponent {
  @ViewChild('modals', { static: true }) modalComponent!: ModalsComponent;
  @ViewChild('toast', { static: true }) toastComponent!: ToastComponent;
  @ViewChild('sidebar', { static: true, read: ElementRef })
  sidebar!: ElementRef;
  preview = viewChild.required<PreviewImageComponent>('preview');

  // injectables
  modals = inject(ModalsService);
  toast = inject(ToastService);
  previewService = inject(PreviewImageService);

  // data
  navLinks!: SidebarLink[];

  ngOnInit() {
    this.modals.bindComponent(this.modalComponent);
    this.toast.bindComponent(this.toastComponent);
    this.previewService.bindComponent(this.preview());
    this.initSidebar();
  }

  initSidebar() {
    this.navLinks = [
      {
        name: 'Dashboard',
        icon: 'bi-house',
        url: '/approver',
      },
      {
        name: 'Quotation',
        icon: 'bi-tags',
        url: '/approver/quotation',
      },
      {
        name: 'Products',
        icon: 'bi-box',
        url: '/approver/products',
      },
      {
        name: 'Events',
        icon: 'bi-calendar-event',
        url: '/approver/events',
      },
      {
        name: 'Activity Logs',
        icon: 'bi-clock',
        url: '/approver/activity-logs',
      },
      {
        name: 'Activity Logs',
        icon: 'bi-clock',
        url: '/approver/activity-logs',
      },
      {
        name: 'FAQs',
        icon: 'bi-question-circle',
        url: '/approver/manage-faq'
      },
      // {
      //   name: 'Settings',
      //   icon: 'bi-gear',
      //   url: '/approver/settings',
      // },
    ];
  }

  showSidebar() {
    this.sidebar?.nativeElement.focus();
  }
}
